'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import QRCode from 'qrcode';

interface MfaQrCodeProps {
  value: string;
  label: string;
}

export function MfaQrCode({ value, label }: MfaQrCodeProps) {
  const [qrCode, setQrCode] = useState({
    value: '',
    dataUrl: null as string | null,
    hasError: false,
  });

  useEffect(() => {
    let isMounted = true;

    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 176,
      color: {
        dark: '#111827',
        light: '#ffffff',
      },
    })
      .then((url) => {
        if (isMounted) {
          setQrCode({ value, dataUrl: url, hasError: false });
        }
      })
      .catch(() => {
        if (isMounted) {
          setQrCode({ value, dataUrl: null, hasError: true });
        }
      });

    return () => {
      isMounted = false;
    };
  }, [value]);

  const isCurrentValue = qrCode.value === value;
  const dataUrl = isCurrentValue ? qrCode.dataUrl : null;

  if (isCurrentValue && qrCode.hasError) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <div className="flex size-48 items-center justify-center rounded-md border bg-white p-2">
        {dataUrl ? (
          <Image src={dataUrl} alt={label} width={176} height={176} unoptimized className="size-44" />
        ) : (
          <div className="size-44 animate-pulse rounded bg-muted" aria-hidden="true" />
        )}
      </div>
    </div>
  );
}
